import React from 'react'
import {
    DemoIcon,
    ArityLogo,
    ArticleLogo,
    NuvoLogo,
    AvanzaLogo,
    DownloadBigIcon,
    MarineLogo,
    PlaytikaLogo,
    VortexaLogo,
    VisecaLogo,
    AdidasLogo,
    BlumeLogo,
    PoeLogo,
    DaimlerLogo,
    CameoLogo,
    CityFibreLogo,
    EPLogo,
    EuroInformationLogo,
    FlippLogo,
    GeneraliLogo,
    GeotabLogo,
    HoneyBookLogo,
    KandjiLogo,
    PlexusLogo,
    OtpBankLogo,
    OCTannerLogo,
    TelnetLogo,
    SasLogo,
    Babylon,
    FlowTradersLogo,
} from '../../lib/components/basics/icons'

import whatIfMediaImg from '../../../resources/images/hanzo/customers/what-if-media-thumbnail.webp'
import arityImg from '../../../resources/images/hanzo/customers/arity-thumbnail.webp'
import articleImg from '../../../resources/images/hanzo/customers/article-thumbnail.webp'
import avanzaImg from '../../../resources/images/hanzo/customers/avanza-thumbnail.webp'
import babylonImg from '../../../resources/images/hanzo/customers/babylon-thumbnail.webp'
import marineImg from '../../../resources/images/hanzo/customers/marineTraffic-thumbnail.webp'
import nuvoImg from '../../../resources/images/hanzo/customers/nuvo-thumbnail.webp'
import playtikaImg from '../../../resources/images/hanzo/customers/playtika-thumbnail.webp'
import visecaImg from '../../../resources/images/hanzo/customers/viseca-thumbnail.webp'
import vortexaImg from '../../../resources/images/hanzo/customers/vortexa-thumbnail.webp'
import { OptionCardProps } from '../../lib/components/components/option-card/types'
import whatIfMediaLogoImg from './what-if-media-logo.png'

// HERO PROPERTIES (Used in HeroModule component)
export const heroProps = {
    alignment: 'LEFT' as const,
    color: 'blue' as const,
    title: (
        <>
            How <b>Arity</b> accelerated their Kafka adoption and saved costs by 40%
        </>
    ),
    primaryCtaLink: '/customers/arity-apache-kafka-costs-amazon-msk',
    primaryCtaLabel: 'Read case study',
}

export const featuredStoriesCardsData = [
    {
        title: 'Innovating with multi-Kafka tooling',
        href: '/customers/what-if-media-innovates-multi-kafka-tooling/',
        logo: <img src={whatIfMediaLogoImg} alt='what-if-media-logo' />,
        imageSrc: whatIfMediaImg,
        imageAlt: 'what-if-media-thumbnail',
    },
    {
        title: 'How Arity accelerated their Kafka adoption and saved costs by 40%',
        href: '/customers/arity-apache-kafka-costs-amazon-msk/',
        logo: <ArityLogo key='arity-2' />,
        imageSrc: arityImg,
        imageAlt: 'arity-thumbnail',
    },
    {
        title: 'How Article is winning market share using Apache Kafka',
        href: '/customers/article-wins-marketshare-using-apache-kafka/',
        logo: <ArticleLogo key='aws' />,
        imageSrc: articleImg,
        imageAlt: 'article-thumbnail',
    },
    {
        title: 'Accessing and processing real-time heart rate data',
        href: '/customers/how-nuvo-processes-real-time-data-with-apache-kafka/',
        logo: <NuvoLogo key='nuvo' />,
        imageSrc: nuvoImg,
        imageAlt: 'nuvo-thumbnail',
    },
    {
        title: 'How developers democratize data across all their Kafka Streams',
        href: '/customers/avanza/',
        logo: <AvanzaLogo key='avanza' />,
        imageSrc: avanzaImg,
        imageAlt: 'avanza-thumbnail',
    },
    {
        title: 'Accelerating data engineering to improve the health of millions',
        href: '/videos/babylon-health-dataops-apache-kafka/',
        logo: <Babylon key='baylon' />,
        imageSrc: babylonImg,
        imageAlt: 'babylon-thumbnail',
    },
    {
        title: 'How MarineTraffic tracks shipping fleet data with Apache Kafka',
        href: '/customers/marine-traffic/',
        logo: <MarineLogo key='marine' />,
        imageSrc: marineImg,
        imageAlt: 'marine-thumbnail',
    },
    {
        title: 'How Playtika takes DataOps to production with Lenses',
        href: '/customers/playtika/',
        logo: <PlaytikaLogo key='playtika' />,
        imageSrc: playtikaImg,
        imageAlt: 'playtika-thumbnail',
    },
    {
        title: 'How Lenses makes Kafka smooth sailing at Vortexa',
        href: '/customers/vortexa/',
        logo: <VortexaLogo key='vortexa' />,
        imageSrc: vortexaImg,
        imageAlt: 'vortexa-thumbnail',
    },
    {
        title: 'A Streaming Data Platform for real-time customer interactions',
        href: '/customers/viseca/',
        logo: <VisecaLogo key='viseca' />,
        imageSrc: visecaImg,
        imageAlt: 'viseca-thumbnail',
    },
]

// GRAPHICS AND LOGOS
export const graphicsAndLogos = {
    title: 'One operating layer all your Kafkas',
    logos: [
        <PoeLogo key='poe' />,
        <AdidasLogo key='adidas' />,
        <ArityLogo key='arity' />,
        <BlumeLogo key='blume' />,
        <CameoLogo key='cameo' />,
        <CityFibreLogo key='city-fibre' />,
        <DaimlerLogo key='daimler' />,
        <EPLogo key='ep' />,
        <EuroInformationLogo key='euro-information' />,
        <FlippLogo key='flipp' />,
        <GeneraliLogo key='generali' />,
        <GeotabLogo key='geotab' />,
        <HoneyBookLogo key='honeybook' />,
        <KandjiLogo key='kandji' />,
        <MarineLogo key='marine' />,
        <OCTannerLogo key='oc-tanner' />,
        <OtpBankLogo key='otp-bank' />,
        <PlaytikaLogo key='playtika' />,
        <PlexusLogo key='plexus' />,
        <TelnetLogo key='telnet' />,
        <SasLogo key='sas' />,
        <VortexaLogo key='vortexa' />,
        <VisecaLogo key='viseca' />,
        <FlowTradersLogo key='flow-traders' />,
    ],
}

export const preFooterTitle = 'Try Lenses for yourself'

export const cardsDataPrefooter: OptionCardProps[] = [
    {
        title: (
            <>
                20 minute
                <br />
                demo
            </>
        ),
        type: 'primary',
        description: [
            'Guided tour of Lenses',
            'Trial key to install on your clusters',
            'Great for production and large-scale Kafka deployments',
        ],
        buttonText: 'Get a demo',
        href: '/request-demo',
        icon: <DemoIcon key='demoIcon' />,
    },
    {
        title: 'Free Lenses',
        leadingText: 'Run the docker command to get Lenses Community Edition:',
        type: 'secondary',
        description: [
            'Apache Kafka Docker + Lenses 6.0',
            'Pre-loaded synthetic data',
            'Up to 2 users + environments',
        ],
        buttonText: 'Download',
        href: '/community-edition/',
        icon: <DownloadBigIcon key='downloadBigIcon' />,
    },
]
